module.exports = __webpack_public_path__ + "img/keynote_1.a111f7b1.png";